import React from 'react';
import { useSubscriptionImport } from './SubscriptionImportContext';

const SubscriptionStep2Type: React.FC = () => {
  const {
    existingTypes,
    typeSelection,
    setTypeSelection,
    selectedType,
    setSelectedType,
    newTypeName,
    setNewTypeName,
  } = useSubscriptionImport();

  return (
    <div className="type-selection-section">
      <div className="type-option">
        <label>
          <input
            type="radio"
            className="type-radio"
            checked={typeSelection === 'existing'}
            onChange={() => setTypeSelection('existing')}
          />
          Vorhandenen Typ auswählen
        </label>
        {typeSelection === 'existing' && (
          <div className="existing-types-list">
            {existingTypes.length > 0 ? (
              existingTypes.map((type) => (
                <button
                  key={type}
                  className={`type-button ${selectedType === type ? 'selected' : ''}`}
                  onClick={() => setSelectedType(type)}
                >
                  {type}
                </button>
              ))
            ) : (
              <p className="no-data-message">Keine vorhandenen Typen gefunden</p>
            )}
          </div>
        )}
      </div>

      <div className="type-option">
        <label>
          <input
            type="radio"
            className="type-radio"
            checked={typeSelection === 'new'}
            onChange={() => setTypeSelection('new')}
          />
          Neuen Typ erstellen
        </label>
        {typeSelection === 'new' && (
          <input
            type="text"
            className="new-type-input"
            placeholder="Name des neuen Typs eingeben..."
            value={newTypeName}
            onChange={(e) => setNewTypeName(e.target.value)}
          />
        )}
      </div>
    </div>
  );
};

export default SubscriptionStep2Type;
